const constants = {
  'RETURN_PROCESS_未処理': 1,
  'RETURN_PROCESS_新品': 2,
  'RETURN_PROCESS_相殺待ち': 3,
  'RETURN_PROCESS_相殺済み': 4,
  'RETURN_PROCESS_代替待ち': 5,
  'RETURN_PROCESS_代替済み': 6,
  'RETURN_PROCESS_破棄待ち': 7,
  'RETURN_PROCESS_破棄済み': 8,
  'RETURN_PROCESS_アウトレット': 9
}

const inventoryStatus = {
  'UNTREATED': 1,
  'PROCESSED': 2
}

const QuantityProduct = {
  'OUT_OF_PRODUCT': '在庫がありません'
}

const ReplacementStatus = {
  'UNTREATED': 1,
  'WAITING_FOR_RETURN': 2,
  'PROCESSED': 3
}

const CONDITIONS_INVENTORY = {
  good: {
    value: 0,
    label: '良品'
  },
  bad: {
    value: 1,
    label: '不良品'
  },
  outlet: {
    value: 2,
    label: 'アウトレット'
  }
}

const RevenueAndProfitFilterType = {
  date: 0,
  year: 1
}

const MapReturnStatusAdminEmail = {
  waitConfirm: 10,
  allConfirm: 11,
  waitConfirmText: '承認待ち',
  allConfirmText: '承認済み'
}

const ReasonReturn = {
  reasonTemporary: '1',
  reason: '0'
}

const DivisionType = [
  {
    'value': 'A',
    'label': '出荷'
  },
  {
    'value': 'D',
    'label': '見積受注出荷'
  },
  {
    'value': 'B',
    'label': '移動'
  },
  {
    'value': 'C',
    'label': '貸出'
  },
  {
    'value': 'E',
    'label': '取置'
  }
]

const BankCompany = [
  {
    'value': 'A',
    'label': 'りそな銀行 秋葉原支店 | 普通預金 1967756'
  },
  {
    'value': 'B',
    'label': '三井住友銀行 柏支店 | 普通預金 8356989'
  },
  {
    'value': 'C',
    'label': '楽天銀行 第二営業支店 | 普通預金 7147045'
  }
]

const OrderStatus = {
  'ORTHER_SHIPPING': 0,
  'NOT_SHIPPED': 1,
  'SHIPPED': 2,
  'PARTIAL_SHIPMENT': 3,
  'ALL': 4,
  'MOVED': 5,
  'NOT_RESERVED': 6,
  'RESERVE_COMPLETED': 7,
  'PARTIAL_RESERVE': 8,
  'MOVE': 9,
  'MOVING': 10,
  'BACKORDER_MANAGE': 11,
  'MOVE_RESERVED': 12,
  'MOVE_PARTIAL_RESERVED': 13,
  'RESERVE_COMPLETED_PARTIAL': 14
}

const WareHouse = {
  'ALL_INVENTORY': 0,
  'ALL_CONSIGNMENT': -1,
  'TOTAL_INVENTORY': -2
}
const Condition = {
  'GOOD': 0,
  'BAD': 1,
  'OUTLET': 2,
  'ALL': 3,
  'CHOICE': 4
}

const YamadaItemFields = [
  'order_number', 'order_at', 'sale_slip', 'uniform_sale_slip', 'uniform_sale_slip_code', 'direct_delivery_designation',
  'consignment_classification', 'red_slip_designation', 'red_slip_compatible', 'estimate_number', 'younosuke_company_customer_code',
  'younosuke_company_name', 'tax_rate_code', 'younosuke_destination_hanbaiocode', 'younosuke_destination_name', 'internal_person_code',
  'billing_customer_code', 'billing_customer_name', 'occasional_billing_category', 'sale_closing_at', 'invoice_date', 'invoice_issued',
  'months_for_forwarding_billing', 'collection_date_deadline', 'scheduled_shipping_date', 'shipped', 'delivery_note_issued', 'sticky_note_1',
  'sticky_note_2', 'remarks', 'advertisement_planning_classification', 'special_support_taxinclusive', 'sale_detail_number', 'sale_detail_classification',
  'warehouse_code', 'shipped', 'product_code', 'product_name', 'product_model', 'product_color', 'product_size', 'calculation_formula_code',
  'calculated_value_1', 'calculated_value_2', 'calculated_value_3', 'quantity_sold', 'number_boxes', 'quantity', 'unit_quantity',
  'unit_price', 'origin_price', 'tax_classification', 'taxable_business_classification', 'memo', 'total_price', 'total_gross_profit'
]

const YamadaCsvFields = [
  '売上伝票.売上伝票番号', '売上伝票.売上伝票日付', '売上伝票.売上伝票区分', '売上伝票.統一伝票区分', '売上伝票.統一伝票分類コード', '売上伝票.直送指定', '売上伝票.委託区分',
  '売上伝票.赤伝票指定', '売上伝票.赤伝対応伝票番号', '売上伝票.見積番号', '売上伝票.得意先コード', '売上伝票.得意先名', '売上伝票.税率区分コード（明細）', '売上伝票.発送先コード',
  '売上伝票.発送先名', '売上伝票.自社担当者コード', '売上伝票.請求得意先コード', '売上伝票.請求得意先名', '売上伝票.随時請求区分', '売上伝票.請求予定日', '売上伝票.請求書発行日',
  '売上伝票.請求書発行済み', '売上伝票.請求先送月数', '売上伝票.回収日締切', '売上伝票.発送予定日', '売上伝票.発送済', '売上伝票.納品書発行済み', '売上伝票.付箋１', '売上伝票.付箋２',
  '売上伝票.摘要', '売上伝票.広告企画区分', '売上伝票.税込税計算の特例対応', '売上伝票.売上明細番号', '売上伝票.売上明細区分', '売上伝票.倉庫コード', '売上伝票.発送済', '売上伝票.商品コード',
  '売上伝票.商品名', '売上伝票.規格・型番', '売上伝票.カラー', '売上伝票.サイズ', '売上伝票.計算式コード', '売上伝票.計算値１', '売上伝票.計算値２', '売上伝票.計算値３', '売上伝票.販売入数',
  '売上伝票.箱数', '売上伝票.数量', '売上伝票.数量単位', '売上伝票.単価', '売上伝票.原単価', '売上伝票.課税区分', '売上伝票.簡易課税事業区分', '売上伝票.備考', '売上伝票.金額', '売上伝票.粗利益'
]

const YahooItemFields = [
  'order_number', 'delivery_name_1', 'delivery_name_2', 'post_code', 'delivery_address_1', 'delivery_address_2', 'delivery_address_3', 'delivery_tel', 'picking_instruction_notes',
  'desired_delivery_date', 'specify_delivery_time', 'cash_delivery_amount', 'payment_category', 'invoice_notes_section', 'purchase_name_1', 'purchase_name_2', 'buyer_postal_code',
  'buyer_address_1', 'buyer_address_2', 'buyer_address_3', 'purchase_tel', 'product_code', 'quantity'
]

const YahooCsvFields = [
  '受注番号', '配送先名称１', '配送先名称２', '配送先郵便番号', '配送先住所１', '配送先住所２', '配送先住所３', '配送先ＴＥＬ', 'ピッキング指示備考', '配達希望日', '配達時間指定', '代金引換金額', '支払区分',
  '送り状備考欄', '購入者名称１', '購入者名称２', '購入者郵便番号', '購入者住所1', '購入者住所2', '購入者住所3', '購入者TEL', '商品コード', '数量'
]

const DiscardStatus = {
  'NOT_PROCESSED': 0,
  'PROCESSED': 1
}

const StatusProduct = [2, 9, 1]

export { inventoryStatus, QuantityProduct, ReplacementStatus, CONDITIONS_INVENTORY, RevenueAndProfitFilterType, MapReturnStatusAdminEmail, DivisionType, ReasonReturn, BankCompany, OrderStatus, WareHouse, Condition, StatusProduct, YamadaItemFields, YamadaCsvFields, YahooItemFields, YahooCsvFields, DiscardStatus }
export default constants
